<template>
  <div>
  <v-text-field :prepend-icon="doc.AttachmentName !== '' ? 'mdi-cloud-tags' : ''" @click="onClick" @change="onChange" background-color="#cdcdcd" :disabled="disabled" solo flat :prefix="(doc.DocClass === undefined || doc.DocClass === null ) ? '' : (doc.DocClass.Name.length === 0) ? '' : '  [' + doc.DocClass.Name + ']'"
  dense style="margin: 0; padding: 0; max-width: 300px;"
  :hide-details="true"
  v-model="doc.Name"></v-text-field>
  <v-icon style="position: absolute; right: 25px; top: 20px;">{{ isExpanded ?  'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
  </div>
</template>

<script>
export default {
  name: 'DocumentTitle',
  emits: ['change'],
  props: {
    doc: {
      type: Object
    },
    documents: {
      type: Array
    },
    indicator: {
      type: Array
    }
  },
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    isExpanded () {
      const index = this.documents.indexOf(this.doc)
      if (this.indicator.indexOf(index) > -1) return true
      return false
    }
  },
  methods: {
    async onChange (val) {
      this.$emit('change', val)
    },
    async onClick (ev) {
      console.log('click button')
      ev.preventDefault()
      ev.stopImmediatePropagation()
      this.disabled = false
    }
  },
  mounted () {
    this.$parent.$on('click', this.dblClick)
  },
  expose: ['dblClick']
}
</script>
